/* Issue #9 — Recently Viewed.
   Pushes current PDP into localStorage on every product view (dedup + FIFO cap).
   Renders up to N items excluding the current product. No color selector — simple ATC only.
*/
(function () {
  'use strict';
  var KEY = 'sm_recently_viewed_v1';
  var MAX = 12;

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY) || '[]'); } catch (e) { return []; }
  }
  function write(arr) {
    try { localStorage.setItem(KEY, JSON.stringify(arr.slice(0, MAX))); } catch (e) {}
  }

  // Capture current PDP meta — main-product.liquid emits [data-sm-pdp-meta].
  function currentPdpMeta() {
    var jsonNode = document.querySelector('[data-sm-pdp-meta]');
    if (!jsonNode) return null;
    try {
      var p = JSON.parse(jsonNode.textContent);
      if (!p || !p.id) return null;
      return {
        id: p.id,
        handle: p.handle,
        title: p.title,
        price: p.price,
        image: p.image,
        url: p.url || ('/products/' + p.handle),
      };
    } catch (e) { return null; }
  }

  function addCurrent() {
    var meta = currentPdpMeta();
    if (!meta) return;
    var list = read();
    // Dedup by id; move to front
    list = list.filter(function (x) { return x.id !== meta.id; });
    list.unshift(meta);
    write(list);
  }

  function formatMoney(priceCents) {
    // Best-effort — mirror Shopify.formatMoney if present, else fall back to plain integer cents
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(priceCents); } catch (e) {}
    }
    return '$' + (priceCents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function render(section) {
    var listEl = section.querySelector('[data-recently-viewed-list]');
    var excludeHandle = section.getAttribute('data-exclude-handle') || '';
    var limit = parseInt(section.getAttribute('data-limit'), 10) || 8;
    if (!listEl) return;

    var items = read().filter(function (x) { return x.handle !== excludeHandle; }).slice(0, limit);
    if (!items.length) { section.setAttribute('hidden', ''); return; }

    var frag = document.createDocumentFragment();
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'recently-viewed__item';

      var wrapper = document.createElement('a');
      wrapper.href = it.url || ('/products/' + it.handle);
      wrapper.className = 'recently-viewed__link';

      var imgWrap = document.createElement('span');
      imgWrap.className = 'recently-viewed__image';
      var img = document.createElement('img');
      img.src = it.image || '';
      img.alt = it.title || '';
      img.loading = 'lazy';
      imgWrap.appendChild(img);
      wrapper.appendChild(imgWrap);

      var t = document.createElement('p');
      t.className = 'recently-viewed__title';
      t.textContent = (it.title || '').split(' in ')[0];
      wrapper.appendChild(t);

      // Per Alex 2026-04-30: order TITLE → COLOR → PRICE. Color is plain text,
      // value only (NO "Color:" label, NO caret, NO select).
      var colorName = (it.title || '').split(' in ')[1];
      if (colorName) {
        var row = document.createElement('span');
        row.className = 'recently-viewed__color';
        row.textContent = colorName;
        wrapper.appendChild(row);
      }

      var price = document.createElement('p');
      price.className = 'recently-viewed__price';
      price.textContent = typeof it.price === 'number' ? formatMoney(it.price) : '';
      wrapper.appendChild(price);

      li.appendChild(wrapper);
      frag.appendChild(li);
    });
    listEl.innerHTML = '';
    listEl.appendChild(frag);
    section.removeAttribute('hidden');
  }

  function bindArrow(section) {
    var list = section.querySelector('[data-recently-viewed-list]');
    var btn = section.querySelector('[data-recently-viewed-next]');
    if (!list || !btn) return;
    btn.addEventListener('click', function () {
      var first = list.querySelector('.recently-viewed__item');
      var w = first ? first.getBoundingClientRect().width + 16 : list.clientWidth / 4;
      list.scrollBy({ left: w, behavior: 'smooth' });
    });
  }

  function init() {
    addCurrent();
    document.querySelectorAll('[data-recently-viewed]').forEach(function (s) {
      render(s);
      bindArrow(s);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
